/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';
import {PageState} from '@ion/applications/src/types/pages';
import {ServiceError} from '@ion/core/src/types/services';

export interface KeyfileBuilderState extends PageState {
  keyfileBuilder: {
    error: ServiceError;
    loading: boolean;
  }
};
// defines the initial state for the reducer ...
export const initialState: KeyfileBuilderState = {
  isInitialized  : false,
  keyfileBuilder : {
    error   : null,
    loading : false
  }
};

// defines the preference key for the toolbox keyyfile builder page ...
export const PREFERENCE = 'schedule-keyfileBuilder';

// defines this reducers reducer functions ...
const reducers = {
};

// defines all reducers for actions of interest to the this reducer ...
export default produce((draft: KeyfileBuilderState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
